  import React from "react";
  import { CiChat1 } from "react-icons/ci";
  import { LuLinkedin } from "react-icons/lu";
  import { FaRedditAlien } from "react-icons/fa";
  import { RiTwitterXFill } from "react-icons/ri";
  import { IoIosLink } from "react-icons/io";
  import { MdOutlineDeleteOutline } from "react-icons/md";

  const SocialMedia = ({ posts }) => {
    const getIcon = (url) => {
      if (url.includes("reddit.com")) {
        return <FaRedditAlien className="w-5 h-5 text-orange-500" />;
      }
      if (url.includes("linkedin.com")) {
        return <LuLinkedin className="w-5 h-5 text-blue-600" />;
      }
      if (url.includes("twitter.com")) {
        return <RiTwitterXFill className="w-5 h-5 text-gray-800" />;
      }
      return null;
    };

    return (
      <div className="h-full flex flex-col">
        {/* Header - fixed height */}
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <CiChat1 className="w-6 h-6 text-gray-600" />
              <h2 className="text-xl font-bold">
                Social Media Discussions
              </h2>
            </div>
            {/* <div className="flex gap-2">
              <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <FiRefreshCcw className="w-4 h-4 text-gray-600" />
              </button>
              <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
                <TfiFullscreen className="w-4 h-4 text-gray-600" />
              </button>
            </div> */}
          </div>
        </div>

        {/* Content - scrollable */}
        <div className="flex-1 overflow-y-auto p-4">
          <ul className="space-y-3">
            {posts.map((post, index) => (
              <li
                key={index}
                className="group flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-gray-300 hover:bg-gray-50 transition-all duration-200"
              >
                <div className="flex-shrink-0">
                  {getIcon(post.url)}
                </div>
                <a
                  href={post.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-grow text-sm font-medium text-gray-800 hover:text-gray-600 line-clamp-2"
                >
                  {post.title}
                </a>
                <div className="flex gap-2 transition-opacity">
                  <a
                    href={post.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-lg hover:bg-gray-200 transition-colors"
                  >
                    <IoIosLink className="w-4 h-4 text-gray-600 hover:text-gray-800" />
                  </a>
                  <button className="p-2 rounded-lg hover:bg-gray-200 transition-colors">
                    <MdOutlineDeleteOutline className="w-4 h-4 text-gray-600 hover:text-red-700" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  export default SocialMedia;